export enum SubmissionType {
  SUBMIT = 0,
  ERROR = 1,
  OTHER = 2
}
